/* eslint-disable no-useless-escape */

import { v4 as uuid } from 'uuid';
import {
    strParamsToArray,
    // stringToBool,
    isStringTruthy,
} from '../../../../commons/utils/strings';

import {
   validateEmail,
} from '../../../../commons/validations';

import isEmpty from 'lodash/isEmpty';

/*
 * Manage AppStore and EnvStore Page and Params
 */

/*
 * Invoked from env.initApp()
 */

export function initParams () {
    const env = this.env;
    const location = window.location;
    const urlSearchParams = new URLSearchParams(location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    if (!validateEmail(params.email)) {
        delete params.email;
    }

    console.log('appStore.initParams(): history.length -> ', window.history.length);
    
    env.page = {
        path: location.pathname,
        params: params,
        sessionSettings: env.getSessionSettings(),
        location,
        completePath: `${location.href}`,
    };
    // initialize browser history
    this.params = params;
    window.history.replaceState({ url:  env.page.completePath }, '', env.page.completePath);
    
    console.log('appStore.initParams(): this.params: ', this.params );
    console.log('appStore.initParams(): page: ',  env.page);
    if (params.mode === 'preview') {
        this.isPreview = true;
    }

    if ((params.widgetId && params.apiKey) || params.mode === 'preview') {
        this.directLink = true;
        this.launchFromDirectLink(env.page);
    } else {
        this.directLink = false;
    }

    this.observed.directLink = uuid();

    return params;
}

export function manageParams () {
    const env = this.env;
    // note : both AppStore.params and Env.page.params points to the same object. 
    // use only for scope context
    this.params = env.page.params;
    this.fixParamsCasing();
    this.fixParamsTypes();
    this.fixMacros();
    this.fixPriorities();
    this.manageFieldParams();
}

export function fixParamsCasing () {
    const names = {
        autosubscribe: 'autoSubscribe',
    };
    for (let key in names) {
        const name = names[key];
        if (name && !this.params[name]) {
            this.params[name] = this.params[key];
            delete this.params[key];
        }
    }
}

/*
 * fix param types if strings to array
 */

export function fixParamsTypes () {
    const env = this.env;
    const params = this.params;
    if (typeof params.calendarIds === 'string') {
        env.page.params.calendarIds = strParamsToArray(params.calendarIds);
    }
    if (typeof this.params.calendar_reference === 'string') {
        
        env.page.params.calendar_reference = strParamsToArray(params.calendar_reference);
    }

    // env.page.params.skip_schedule_selection = stringToBool(params.skip_schedule_selection);
   
    this.params.autoSubscribe = isStringTruthy(params.autoSubscribe);

    // console.log('PRE params.skip_schedule_selection: ', params.skip_schedule_selection);
    this.params.skip_schedule_selection = isStringTruthy(params.skip_schedule_selection);
    /// console.log('POST params.skip_schedule_selection: ', params.skip_schedule_selection);
    env.page.params.skip_schedule_selection = this.params.skip_schedule_selection;
   
   
    if (typeof this.params.category === 'string') {
        const illegal = /[\[\]"]/g;
        this.params.category = this.params.category.replaceAll(illegal, '');
    }

    /* when category is Array convert it to string */
    if (Array.isArray(this.params.category)) {
        this.params.category = this.params.category.join(',');
    }
};

export function fixMacros () {
    // replace MACRO VALUES
    if (this.params.category && this.location.country_code) {
        this.params.category = this.params.category.replaceAll('{{ECAL_USER_COUNTRYCODE}}', this.location.country_code);
    }
}

export function fixPriorities () {
    let skip_schedule_selection = this.params.skip_schedule_selection || this.widget.skip_schedule_selection;
    if (!isEmpty(this.params.category) || 
        !isEmpty(this.params.calendar_reference) || 
        !isEmpty(this.params.calendarIds)
    ) {
        skip_schedule_selection = false;
    }
    this.skip_schedule_selection = skip_schedule_selection;
}

export function manageFieldParams () {
    const env = this.env;
    const uistates = env.uiStatesStore;
    uistates.setParamFieldValues();
}

const paramsMethods = {
    initParams,
    manageFieldParams,
    manageParams,
    fixParamsCasing,
    fixParamsTypes,
    fixMacros,
    fixPriorities,
};

export default paramsMethods;